import { render, staticRenderFns } from "./DependentsDialog.vue?vue&type=template&id=2abe4f5e&scoped=true"
import script from "./DependentsDialog.vue?vue&type=script&lang=js"
export * from "./DependentsDialog.vue?vue&type=script&lang=js"
import style0 from "./DependentsDialog.vue?vue&type=style&index=0&id=2abe4f5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abe4f5e",
  null
  
)

export default component.exports